import {useTranslation} from "react-i18next";
import contractorRolesOptions from "constants/contractorRolesOptions";
import {ReadOnlyCheckbox} from "components/Shared/ReadOnlyCheckbox";
import React from "react";

export function ContractorRolesReadonlyCheckboxGroup({roles, previousRoles}) {
    const {t} = useTranslation()
    return (
        <div>
            <h2>{t('contractor.form.roles')}</h2>
            {contractorRolesOptions.map(option => (
                <div key={option.value} className="pl-1">
                    <ReadOnlyCheckbox
                        checked={roles.includes(option.value)}
                        diffValue={previousRoles?.includes(option.value)}
                        label={t(option.label)}/>
                </div>
            ))}
        </div>
    )
}
